import {
  referenceObject,
  REQUIRED_MESSAGE,
  requiredNumber,
  requiredString,
} from "components/form/utils";
import { z } from "zod";

const optionalUrl = z
  .string()
  .url({ message: "Invalid URL" })
  .or(z.literal(""))
  .optional()
  .or(z.null());

export const userSchema = z.object({
  avatar: z.string().nullable().optional(),
  first_name: requiredString(),
  last_name: requiredString(),
  email: requiredString().email("Invalid email address"),
  employee_id: requiredString(),
  secondary_job_title: z.string().optional().nullable(),
  joining_date: requiredString(),
  consumption_factor: requiredNumber(),
  phone_no: z.string().optional().nullable(),
  emoji: z.string().optional().or(z.literal("")).nullable(),
  x: optionalUrl,
  linkedin: optionalUrl,
  website: optionalUrl,
  title: z.string().optional().or(z.literal("")).nullable(),
  role: requiredString(),
  status: requiredString(),
  job_title: requiredString(),
  reports_to: referenceObject(),
  department: requiredString(),
  grade: requiredString(),
  function: requiredString(),
  allocable: z.boolean().default(false),
});
